import "./TableHeader.css";

const TableHeader = ({
  columns,
  sortConfig,
  handleSort,
  handleSelectAll,
  isAllSelected,
}) => (
  <thead className="custom-table-header">
    <tr>
      {/* Checkbox for select-all */}
      <th className="custom-header-cell custom-checkbox-cell">
        <input
          type="checkbox"
          onChange={handleSelectAll}
          checked={isAllSelected}
        />
      </th>

      {/* Data columns */}
      {columns.slice(0, 6).map((col, idx) => {
        const isActive = sortConfig.field === col.field;
        return (
          <th
            key={idx}
            className={`custom-header-cell custom-sortable ${
              isActive ? `custom-sorted-${sortConfig.direction}` : ""
            }`}
            onClick={() => handleSort(col.field)}
          >
            <span className="custom-header-label">{col.label}</span>
            <span className="custom-sort-indicator">
              {isActive ? (
                sortConfig.direction === "asc" ? (
                  <i className="fas fa-sort-up"></i>
                ) : (
                  <i className="fas fa-sort-down"></i>
                )
              ) : (
                <i className="fas fa-sort"></i> // neutral icon if not sorted
              )}
            </span>
          </th>
        );
      })}

      {/* Actions column */}
      <th className="custom-header-cell custom-actions-cell">Actions</th>
    </tr>
  </thead>
);

export default TableHeader;
